import { SearchProductsApiItem, SearchProductsResponse } from 'src/types/search_products/SearchProducts';
import { getProductImageSrc, parseProductImageUrl } from 'src/utils/parseProductImageUrl';
import { SearchResultProduct } from './searchProductData';

export const mapSearchProductsApiItem = (item: SearchProductsApiItem): SearchResultProduct => {
  const description = item.description?.trim() ?? '';
  const transformedUrl = getProductImageSrc(item.url, {
    productDescription: description || undefined,
    viewType: 'advanced',
  });
  const parsedUrl = parseProductImageUrl(item.url);

  return {
    productKey: `${item.catalogId}-${item.categoryId}-${item.productId}`,
    productId: item.productId,
    supplierId: item.supplierId ?? 0,
    offlineSupplierId: item.offlineSupplierId ?? null,
    supplierCompanyId: item.supplierCompanyId ?? 0,
    itemNum: item.itemNum?.trim() ?? '',
    description,
    casePack: item.casePack?.trim() ?? '',
    basePrice: null,
    manufacturerNumber: item.manufacturerNumber?.trim() ?? '',
    price: item.price ?? 0,
    uom: item.uom?.trim() ?? '',
    itemsPerUom: 1,
    companyName: item.supplierName?.trim() ?? '',
    supplierName: item.supplierName?.trim() ?? '',
    categoryId: item.categoryId,
    catalogName: item.catalogName?.trim() ?? '',
    catalogId: item.catalogId,
    catalogType: item.isOfflineSupplierItem ? 3 : undefined,
    url: item.url,
    minOrder: null,
    currencyId: 1,
    brandName: item.brandName?.trim() ?? '',
    weight: item.weight?.trim() ?? '',
    quantity: 0,
    lastPurchaseDate: null,
    productInFavoriteFolder: false,
    isOfflineSupplierItem: item.isOfflineSupplierItem,
    isContracted: item.isContracted,
    isSpecialOrder: item.isSpecialOrder,
    isImageAvailable: item.isImageAvailable,
    // SearchProducts API does not expose isFormulary; default false for cart/favorites isCompanySpecified.
    isFormulary: false,
    isNoItem: item.isNoItem,
    info: item.info?.trim() ?? '',
    manufacturerName: item.manufacturerName?.trim() ?? '',
    upc: item.upc?.trim() ?? '',
    attributes: [
      item.isContracted ? 'isContracted' : null,
      item.isImageAvailable ? 'isImageAvailable' : null,
      item.isSpecialOrder ? 'isSpecialOrder' : null,
      item.isOfflineSupplierItem ? 'isOfflineSupplierItem' : null,
    ].filter((attribute): attribute is string => attribute !== null),
    linkUrl: '',
    altText: description,
    imageSrc: transformedUrl,
    imageDescription: description,
    isImage: Boolean(item.isImageAvailable && item.url),
    hasUrl: Boolean(item.url),
    ...(parsedUrl as Partial<SearchResultProduct>),
  };
};

export const mapSearchProductsResponse = (
  data: SearchProductsResponse
): { totalRecords: number; items: SearchResultProduct[] } => ({
  totalRecords: data.totalRecords,
  items: (data.items ?? []).map(mapSearchProductsApiItem),
});
